export const newsArticles = [
  {
    id: 1,
    title: 'Stirret Students Excel at National Science Competition',
    excerpt: 'Our students brought home gold medals from the National Science Olympiad, showcasing exceptional talent in physics and chemistry.',
    date: '2024-01-15',
    image: 'https://images.unsplash.com/photo-1532094349884-543bc11b234d?w=600&h=400&fit=crop',
    category: 'Achievement',
    school: 'college',
    slug: 'national-science-competition-2024',
  },
  {
    id: 2,
    title: 'New State-of-the-Art Library Opens',
    excerpt: 'We are thrilled to announce the opening of our newly renovated library featuring over 10,000 books and digital resources.',
    date: '2024-01-10',
    image: 'https://images.unsplash.com/photo-1521587760476-6c12a4b040da?w=600&h=400&fit=crop',
    category: 'Facilities',
    school: 'all',
    slug: 'new-library-opening',
  },
  {
    id: 3,
    title: 'Annual Inter-House Sports Competition',
    excerpt: 'Students across all houses competed in track and field events, displaying remarkable sportsmanship and athletic prowess.',
    date: '2024-01-05',
    image: 'https://images.unsplash.com/photo-1461896836934- voices-of-protest-from-all-sides-of-the-spectrum?w=600&h=400&fit=crop',
    category: 'Sports',
    school: 'college',
    slug: 'inter-house-sports-2024',
  },
  {
    id: 4,
    title: 'Montessori Cultural Day Celebration',
    excerpt: 'Our young learners celebrated Nigeria\'s rich cultural heritage through traditional dances, songs, and colorful costumes.',
    date: '2024-01-02',
    image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=600&h=400&fit=crop',
    category: 'Events',
    school: 'montessori',
    slug: 'montessori-cultural-day',
  },
];
